import Vue from 'vue'
import VueRouter from 'vue-router'
import WelcomeView from '../views/WelcomeView.vue'
import IndividualView from '../views/IndividualView.vue'
import SearchView from '../views/SearchView.vue'
// import HierarchyView from '../views/HierarchyView.vue'
import RealEstateView from '../views/RealEstateView.vue'
// import MapView from '../views/MapView.vue'
import GmapView from '../views/GmapView.vue'
import ApartmentView from '../views/ApartmentView.vue'
import TreeView from '../views/TreeView.vue'
import AssetsView from '../views/AssetsView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'welcome',
    component: WelcomeView,
  },
  {
    path: '/search',
    name: 'search',
    component: SearchView,
  },
  {
    path: '/map',
    name: 'map',
    component: GmapView,
  },
  {
    path: '/individual/:id',
    name: 'individual',
    component: IndividualView,
    props: true,
  },
  {
    path: '/realestate/:id',
    name: 'realestate',
    component: RealEstateView,
    props: true,
  },
  {
    path: '/apartment/:id',
    name: 'apartment',
    component: ApartmentView,
    props: true,
  },
  {
    path: '/tree',
    name: 'tree',
    component: TreeView,
    props: false,
  },
  {
    path: '/assets',
    name: 'assets',
    component: AssetsView,
    props: false,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

// TODO remove for production build...
// router.afterEach(() => {
//   console.log('router.index.after-each', window.history)
// })

export default router
